import { Helmet } from 'react-helmet';
import { ContactPage } from '../components/contactpage/ContactPage';

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us | Lone Wolf Writes</title>
        <meta name="description" content="Lone Wolf Writes Contact Us" />
        <link rel="canonical" href="https://lonewolfwrites.com/contact" />
      </Helmet>
      <main>
        <ContactPage />
      </main>
    </>
  )
};

export default Contact;
